import { print, printDataParse } from '@/utils/print';
import { readUserSelect } from '@/utils/myUtils';

// 根据页面值取值  https://www.kdocs.cn/l/cdBR9PscVo48
export const modulesList = {
  '11': {
    key: ['customerId'],
    value: ['customerId']
  },
  '16': {
    key: ['purchasesReceiptDocId'],
    value: ['purchasesReceiptDocId']
  },
  '18': {
    key: ['repaymentDocId'],
    value: ['repaymentDocId']
  },
  '19': {
    key: ['salesDeliveryDocId'],
    value: ['docId']
  },
  '21': {
    key: ['salesQuotationOrderDocId'],
    value: ['salesQuotationOrderDocId']
  },
  '22': {
    key: ['salesOrderDocId'],
    value: ['salesOrderDocId']
  },
  '23': {
    key: ['materialId', 'specGroupId', 'salesDeliveryDocId'],
    value: ['baseMetaMaterialId', 'baseMetaSpecgroupId', 'salesDeliveryDocId']
  },
  '24': {
    key: ['salesSampleOrderDocId'],
    value: ['salesSampleOrderDocId']
  },
  '31': {
    key: ['purchasesOrderDocId'],
    value: ['purchasesOrderDocId']
  },
  '32': {
    key: ['proddocReturnDoc_view', 'purchasesReceiptDocId'],
    value: ['proddocReturnDoc_view', 'purchasesReceiptDocId']
  },
  '33': {
    key: ['reportId'],
    value: ['reportId']
  },
  '34': {
    key: ['purchaseRequisitionDocId'],
    value: ['purchaseRequisitionDocId']
  },
  '41': {
    key: ['produceDocId'],
    value: ['produceDocId']
  },
  '46': {
    key: ['changeBomId'],
    value: ['changeBomId']
  },
  '47': {
    key: ['outsourcingDocId'],
    value: ['outsourcingDocId']
  },
  '48': {
    key: ['outsourcingRequisitionDocId'],
    value: ['outsourcingRequisitionDocId']
  },
  '49': {
    key: ['outsourcingReturnDocId'],
    value: ['outsourcingReturnDocId']
  },
  '50': {
    key: ['outsourcingtowarehouseId'],
    value: ['outsourcingtowarehouseId']
  },

  '51': {
    key: ['salesChargebackDocId'],
    value: ['salesChargebackDocId']
  },
  '53': {
    key: ['testDocId'],
    value: ['testDocId']
  },
  '66': {
    key: ['specGroupId', 'materialId'],
    value: ['specGroupId', 'materialId']
  },
  '71': {
    key: ['bomId'],
    value: ['bomId']
  },
  '72': {
    key: ['mrpDocId'],
    value: ['mrpDocId']
  },
  '73': {
    key: ['reimburseDocId'],
    value: ['reimburseDocId']
  },
  '74': {
    key: ['supplierId'],
    value: ['supplierId']
  },

  '81': {
    key: ['afterSalesSituationId'],
    value: ['afterSalesSituationId']
  },
  '93': {
    key: ['statementReceiptDocId'],
    value: ['statementReceiptDocId']
  },
  '94': {
    key: ['statementPaymentDocId'],
    value: ['statementPaymentDocId']
  },
  '96': {
    key: ['produceDocId'],
    value: ['produceDocId']
  },
  '97': {
    key: ['produceDocId'],
    value: ['produceDocId']
  },
  '99': {
    key: ['mrpDocId'],
    value: ['mrpDocId']
  },
  '111': {
    key: ['dailyPaperDocId'],
    value: ['dailyPaperDocId']
  },
  '115': {
    key: ['processRouteId'],
    value: ['processRouteId']
  },
  '117': {
    key: ['materialRequisitionId'],
    value: ['materialRequisitionId']
  },
  '122': {
    key: ['supplementaryMaterialId'],
    value: ['supplementaryMaterialId']
  },
  '127': {
    key: ['processOutsourcingDocId'],
    value: ['processOutsourcingDocId']
  },
  '128': {
    key: ['afterSalesRepairDocId'],
    value: ['afterSalesRepairDocId']
  },
  '138': {
    key: ['purchasesInquiryDocDetailSupplierId'],
    value: ['purchasesInquiryDocDetailSupplierId']
  },
  '139': {
    key: ['meetingsDocId'],
    value: ['meetingsDocId']
  }

}
// 获取打印数据和打印数据处理返回
export async function processModules(that, changeList, modules, printFun, isList = false) {
  try {
    const promises = [];
    var printDataList = [];
    console.log('changeList', changeList)
    for (let k = 0; k < changeList.length; k++) {
      const key = modulesList[modules + ''].key;
      const value = modulesList[modules + ''].value;

      const values = [];
      for (const it of value) {
        values.push(changeList[k][it]);
      }

      const form = {};
      for (let [id, it] of key.entries()) {
        form[it] = values[id];
      }
      var isOld = that.isOld ?? false
            
      console.log('start')
      if (printFun) {
        var datakey, datavalue
        Object.keys(form).forEach((key) => {
          if (form[key]) {
            console.log(key, form[key])
            datakey = key
            datavalue = form[key]
          }
        })
        promises.push(printFun(form).then(async (res) => {
          if (!isOld) {
            console.log('this.printData', isOld);
            const printData = { ...changeList[k], ...res.data.data };
            printData.baseDrawingFile = changeList[k].baseDrawingFile
            printData.valueImgList = changeList[k].valueImgList
            printData.qrcode = `{"modules":${modules},"orderId":"${datavalue}"}`;
            if (printData.createUserId) {
              printData.createUserName = await readUserSelect(printData.createUserId);
            }
            const parsedData = await printDataParse(printData);
            printDataList.push(parsedData);
            console.log('this.printData1', isOld);
          }
        }));
      } else {
        await printDataParse(changeList[k]);
        printDataList.push(changeList[k]);
      }
    }
    // 等待所有 promise 解决
    await Promise.all(promises);
    console.log('this.printData', printDataList);
    return printDataList;
  } catch (error) {
    console.error('processModules', error)
  }
}
